import { render } from "./StepCliente.vue?vue&type=template&id=20d4280d&scoped=true"
import script from "./StepCliente.vue?vue&type=script&lang=js"
export * from "./StepCliente.vue?vue&type=script&lang=js"

import "./StepCliente.vue?vue&type=style&index=0&id=20d4280d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d4280d"]])

export default __exports__